import { render, staticRenderFns } from "./Teamee-1.vue?vue&type=template&id=4a50b384&scoped=true&"
import script from "./Teamee-1.vue?vue&type=script&lang=js&"
export * from "./Teamee-1.vue?vue&type=script&lang=js&"
import style0 from "./Teamee-1.vue?vue&type=style&index=0&id=4a50b384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a50b384",
  null
  
)

export default component.exports